import {Component, OnDestroy, OnInit} from '@angular/core';
import {
  DefaultGridButtons,
  GridColumn,
  MxCustomizer,
  MxGridButtonsConfig,
  MxGridCustomizerEvent,
  MxGridService, MxReportViewCustomizerEvent
} from 'mx-core';
import {Router} from '@angular/router';
import {PrlTranslateService} from '../../../../../../shared/services/prl-translate.service';
import {Subject} from 'rxjs';
import {MatDialog} from '@angular/material/dialog';
import {PrlNewPaymentAccountComponent} from '../new-account/prl-new-payment-account.component';
import {PrlEditPaymentAccountComponent} from '../edit-account/prl-edit-payment-account.component';

@Component({
  selector: 'prl-payment-account',
  standalone: false,
  templateUrl: './prl-payment-account.component.html',
  styleUrls: ['./prl-payment-account.scss']
})
export class PrlPaymentAccountComponent implements OnInit, OnDestroy, MxCustomizer<MxGridCustomizerEvent>, MxCustomizer<MxReportViewCustomizerEvent> {
  private buttonsConfig: MxGridButtonsConfig;
  private gridColumns: GridColumn[] = [];
  private gridService: MxGridService;
  private _destroy$$: Subject<void> = new Subject<void>();


  constructor(private readonly router: Router,
              protected readonly translateService: PrlTranslateService,
              private dialogRef: MatDialog
  ) {
  }
  ngOnInit(): void {
    this.gridColumns = [
      new GridColumn({
        field: 'methodName',
        label: ()=> this.translateService.getTranslatedLabel('label.finance.payment.account.payment.method.name'),
        sortable: true,
        hidden: false
      }),
      new GridColumn({
        field: 'default',
        label: ()=> this.translateService.getTranslatedLabel('label.finance.payment.account.is.default'),
        sortable: true,
        hidden: false,
        type: 'boolean'
      }),
      new GridColumn({
        field: 'status',
        label: ()=> this.translateService.getTranslatedLabel('label.finance.payment.account.status'),
        sortable: true,
        hidden: false,
      }),
      new GridColumn({
        field: 'updatedOn',
        label: ()=> this.translateService.getTranslatedLabel('label.finance.payment.account.updated'),
        sortable: true,
        hidden: false,
        type: 'date'
      })
    ];
    this.buttonsConfig = new MxGridButtonsConfig([
      [DefaultGridButtons.add, {
        label: () => this.translateService.getTranslatedLabel('label.finance.payment.account.create.new'),
        icon: 'add',
        color: 'primary',
        tooltip: () => this.translateService.getTranslatedLabel('label.finance.payment.account.create.new'),
        className: 'mxs-button--primary',
        clickHandler: () => this.onAddPaymentAccount()
      }],
      [DefaultGridButtons.edit, {
        tooltip: () => this.translateService.getTranslatedLabel('label.finance.payment.account.edit'),
        hidden: false,
        permission: 'permission.finance.payment_accounts.view',
        className: 'mxs-button--round mxs-button--secondary',
        clickHandler: () => this.onEditPaymentAccount()
      }],
      [DefaultGridButtons.remove, {
        hidden: true
      }],
      [DefaultGridButtons.view, {
        hidden: true
      }],
      [DefaultGridButtons.reload, {
        hidden: true
      }]
    ]);
  }

  onAddPaymentAccount(): void {
      const dialogRef = this.dialogRef.open(PrlNewPaymentAccountComponent, {
      panelClass: 'mx-dialog-panel-class',

    });
    dialogRef.afterClosed().subscribe(() => {
      this.gridService.collection.doReload()
    });
  }

  onEditPaymentAccount(): void {
    const rowId = this.gridService.collection.selection.selected[0].id;
    const dialogRef = this.dialogRef.open(PrlEditPaymentAccountComponent, {
      panelClass: 'mx-dialog-panel-class',
      data: { id: rowId }
    });
    dialogRef.afterClosed().subscribe(() => {
      this.gridService.collection.doReload()
    });
  }

  onCustomize(event: MxGridCustomizerEvent): void {
    event
        .customizeRestUrl('/finance/payment-accounts')
        .customizeItemDetailsLink('/finance/payment-accounts/')
        .customizeLoadRowsOnStart(true)
        .customizeColumns(this.gridColumns)
        .customizeActions(this.buttonsConfig)
        .customizeProps({
          selectionMode: 'single',
          readonly: true,
          showButtons: true,
          showColumns: false
        })
        .onSetUp(service => {
          this.gridService = service;
        });
  }

  ngOnDestroy(): void {
    this._destroy$$.next(null);
  }
}
